import Api from "../../Api";

export const getAncillaryPurchases = async (query) => {
  try {
    let res = await Api.get("/mobile-ancillary/purchases", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getAncillaryPurchaseById = async (id) => {
  try {
    let res = await Api.get("/mobile-ancillary/purchases/" + id);
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getAncillaryErrors = async (query) => {
  try {
    let res = await Api.get("/mobile-ancillary/errors", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getAncillaryErrorById = async (id) => {
  try {
    let res = await Api.get("/mobile-ancillary/errors/" + id);
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getSeawareDescriptions = async (query) => {
  try {
    let res = await Api.get("/seaware-ancillary/descriptions", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const syncSeawareDescriptions = async () => {
  try {
    let res = await Api.post("/seaware-ancillary/sync-descriptions");
    return res?.data || {};
  } catch (e) {
    return { error: "Sync failed. Please try again." };
  }
};
